import type { Database } from "bun:sqlite";
import type { MoneyConfig } from "./session-money";
import type { WithholdingRates } from "./work-contract";

export const MONEY_SETTING_KEYS = {
  vatRate: "session_vat_rate",
  feePercent: "platform_fee_percent",
  recognizedCosts: "wc_recognized_costs_percent",
  incomeTax: "wc_income_tax_percent",
  pension: "wc_pension_percent",
  health: "wc_health_percent",
} as const;

export function getMoneyConfig(db: Database): MoneyConfig {
  return {
    vatRate: readNumber(db, MONEY_SETTING_KEYS.vatRate, 0.17),
    feePercent: readNumber(db, MONEY_SETTING_KEYS.feePercent, 20),
  };
}

export function getWithholdingRates(db: Database): WithholdingRates {
  return {
    recognizedCostsPercent: readNumber(db, MONEY_SETTING_KEYS.recognizedCosts, 20),
    incomeTaxPercent: readNumber(db, MONEY_SETTING_KEYS.incomeTax, 10),
    pensionPercent: readNumber(db, MONEY_SETTING_KEYS.pension, 6),
    healthPercent: readNumber(db, MONEY_SETTING_KEYS.health, 4),
  };
}

function readString(db: Database, key: string, fallback: string): string {
  const row = db.query("SELECT value FROM platform_settings WHERE key = ?").get(key) as
    | { value: string }
    | null;
  return row?.value ?? fallback;
}

function readNumber(db: Database, key: string, fallback: number): number {
  const parsed = parseFloat(readString(db, key, String(fallback)));
  return Number.isFinite(parsed) ? parsed : fallback;
}
